// page control


// #region PRELOADER FUNCTIONS
page.control.preloader.show = function(millis){
    log.webgl("PRELOADER: show");
    if(typeof(millis) != "number" || millis < 1) millis = page.config.preloaderFadeInTime;
    page.three.control.transition.fadeTo(1, millis);
    page.three.control.transition.speedTo(page.config.preloaderParticleSpeed, millis);
    page.three.control.preloader.fadeIn(millis);
    page.three.v.preloader.wait = page.config.preloaderProgressShowDelay;
}

page.control.preloader.hide = function(millis){
    log.webgl("PRELOADER: hide");
    if(typeof(millis) != "number" || millis < 1) millis = page.config.preloaderFadeOutTime;
    page.three.control.transition.fadeTo(0, millis);
    page.three.control.transition.speedTo(0, millis);
    page.three.control.preloader.fadeOut(millis);
}


page.control.preloader.progress = function(progress, millis){
    page.three.control.preloader.progress(progress, millis);
}
// #endregion PRELOADER FUNCTIONS

// #region BACKGROUND FUNCTIONS
page.control.bg.setColor = function(color) { page.three.control.bg.setColor(color); };
page.control.bg.fadeColor = function(color, millis) { log.webgl(`BG: fadeColor(${color}, ${millis})`); page.three.control.bg.fadeColor(color, millis); };
// #endregion BACKGROUND FUNCTIONS

page.control.particles.fadeTo = function(amount, millis){
    page.three.control.transition.fadeTo(amount, millis);
}

page.control.particles.speedTo = function(amount, millis){
    page.three.control.transition.speedTo(amount, millis);
}

page.control.particles.scrolling = function(b){
    page.three.control.transition.scrollEnable(b);
}